import React from 'react';
import { Card, CardActionArea, CardContent, Typography, Box } from '@mui/material';
import { formatEuro, formatPct } from '../../../functions/formatNumber.js';

const ActiuCardAnual = ({ asset, isSelected, onClick }) => {
  const saldoFinal = asset.saldoFinal || 0;
  const aportacions = asset.aportacions || 0;
  const retiros = asset.retiros || 0;
  const rendimientoTotal = asset.rendimientoTotal || 0;

  const retVal = asset.percentatgeRetorn !== undefined && asset.percentatgeRetorn !== null
    ? asset.percentatgeRetorn
    : null;
  const isPositive = (retVal !== null ? retVal : rendimientoTotal) >= 0;
  const colorBadge = isPositive ? '#4CAF50' : '#EF4444';
  const bgBadge = isPositive ? 'rgba(76, 175, 80, 0.12)' : 'rgba(239, 68, 68, 0.12)';
  const borderBadge = isPositive ? '#A5D6A7' : '#FFCDD2';
  const colorRend = rendimientoTotal >= 0 ? '#4CAF50' : '#EF4444';

  const apStr = aportacions > 0 ? `+${formatEuro(aportacions)}` : '0,00 €';
  const retStr = retiros > 0 ? `-${formatEuro(retiros)}` : '0,00 €';

  return (
    <Card
      elevation={isSelected ? 3 : 1}
      sx={{
        borderRadius: '12px',
        border: isSelected ? '2px solid #3F51B5' : '1px solid #E0E0E0',
        backgroundColor: isSelected ? 'rgba(63, 81, 181, 0.04)' : '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <CardActionArea onClick={onClick}>
        <CardContent sx={{ p: '12px !important' }}>
          {/* Capçalera */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', lineHeight: 1.2, pr: 1 }}>
              {asset.nom}
            </Typography>
            {retVal !== null && (
              <Box
                sx={{
                  backgroundColor: bgBadge,
                  color: colorBadge,
                  border: `1px solid ${borderBadge}`,
                  borderRadius: '12px',
                  px: 1,
                  py: 0.2,
                  fontSize: '0.8rem',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                }}
              >
                {retVal >= 0 ? '+' : ''}{formatPct(retVal)}
              </Box>
            )}
          </Box>

          {/* Bloc de mètriques */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 1,
              mt: 1,
              pt: 1,
              borderTop: '1px dashed #EEEEEE',
            }}
          >
            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.7rem' }}>
                SALDO FINAL
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {formatEuro(saldoFinal)}
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.7rem' }}>
                RENDIMENT
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: colorRend }}>
                {rendimientoTotal >= 0 ? '+' : ''}{formatEuro(rendimientoTotal)}
              </Typography>
            </Box>
            <Box sx={{ gridColumn: 'span 2' }}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.7rem' }}>
                APORTAT / RETIRAT
              </Typography>
              <Typography variant="body2">
                <Box component="span" sx={{ color: aportacions > 0 ? '#4CAF50' : 'text.secondary', fontWeight: aportacions > 0 ? 500 : 400 }}>
                  {apStr}
                </Box>
                {' / '}
                <Box component="span" sx={{ color: retiros > 0 ? '#EF4444' : 'text.secondary', fontWeight: retiros > 0 ? 500 : 400 }}>
                  {retStr}
                </Box>
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ActiuCardAnual;
